import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import tinycolor from "tinycolor2";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormInput,
  FormTextarea,
  Row,
} from "shards-react";
import API from "../Api/API";
import { handleErrorMessage } from "../ErrorMessages/ErrorMessages";
import { showNotification } from "../Notification/Notification";
import CoachSelectForm from "./CoachSelectForm";
import { text } from "@fortawesome/fontawesome-svg-core";

const CoachContactForm = ({ primaryColor, id }) => {
  const { t } = useTranslation(["coach"]);

  const [coach, setCoach] = useState(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const coachResponse = await fetchCoach();
      setCoach(coachResponse);
    };
    getData();
  }, []);

  const fetchUser = () => {
    return axios
      .get(API.url + "api/user/details", {
        withCredentials: true,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleErrorMessage(err.response.status);
      });
  };

  const fetchCoach = () => {
    return axios
      .get(API.url + "api/club/coach", {
        withCredentials: true,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleErrorMessage(err.response.status);
      });
  };

  const primaryColorText = {
    color: primaryColor,
  };

  const primaryColorBg = {
    backgroundColor: primaryColor,
    borderColor: primaryColor,
  };

  const lighterPrimaryColor = tinycolor(primaryColor).brighten(85).toString();
  const backgroundColorStyle = {
    backgroundColor: lighterPrimaryColor,
  };

  const closeDialog = (e) => {
    e.preventDefault();
    document.getElementById(id).style.display = "none";
    document.getElementById("support_message_input").value = "";
    document.getElementById("subject_input").value = "";

    const coachSelectForm = document.getElementById("coach_select_form");
    if (coachSelectForm) {
      coachSelectForm.style.display = "none";
    }
    const coachContactForm = document.getElementById("coach_contact_form");
    if (coachContactForm) {
      coachContactForm.style.display = "block";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    const text = document.getElementById("support_message_input").value;
    if (!text) {
      setDisabled(false);
      return;
    }

    const payload = {
      text: text,
    };

    axios
      .post(API.url + "api/mail/coach/send", payload, { withCredentials: true })
      .then(() => {
        closeDialog(e);
        setDisabled(false);
        showNotification(t("message_sent_successfully"));
      })
      .catch((error) => handleErrorMessage(error.response.status));
  };

  const showSelectForm = () => {
    document.getElementById("coach_contact_form").style.display = "none";
    document.getElementById("coach_select_form").style.display = "block";
  };

  return (
    <div id={id} className="popup_form_container" style={{ display: "none" }}>
      <Card
        className="popup_form"
        style={backgroundColorStyle}
        onMouseDown={function (event) {
          event.stopPropagation();
        }}
      >
        <Button
          className={"close_dialog_button"}
          style={primaryColorText}
          onClick={closeDialog}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
        <CardBody style={{ overflowY: "scroll" }}>
          <Container>
            <div id="coach_contact_form">
              {coach ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="popup_form_title_container mb-5">
                    <Col lg={{ size: 10, offset: 1 }}>
                      <h4 style={primaryColorText}>
                        {t("coach_contact_text")}
                      </h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col lg={{ size: 10, offset: 1 }}>
                      <h2 style={primaryColorText}>
                        {coach.firstName} {coach.lastName}
                      </h2>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col lg={{ size: 10, offset: 1 }}>
                      <FormTextarea
                        id={"support_message_input"}
                        placeholder={t("message")}
                        style={{ minHeight: "86pt" }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col lg={{ size: 4, offset: 4 }}>
                      <Button
                        className="width-100 button save-button"
                        style={primaryColorBg}
                        disabled={disabled}
                      >
                        {t("send")}
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col lg={{ size: 4, offset: 4 }}>
                      <Button
                        className="width-100 button save-button"
                        style={primaryColorBg}
                        onClick={showSelectForm}
                      >
                        {t("change_coach")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <>
                  <Row>
                    <Col lg={{ size: 10, offset: 1 }}>
                      <h4 style={primaryColorText}>{t("no_coach")}</h4>
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col lg={{ size: 4, offset: 4 }}>
                      <Button
                        className="width-100 button save-button"
                        style={primaryColorBg}
                        onClick={showSelectForm}
                      >
                        {t("select_coach")}
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </div>
            <CoachSelectForm
              primaryColor={primaryColor}
              coach={coach}
              setCoach={setCoach}
            />
          </Container>
        </CardBody>
      </Card>
    </div>
  );
};

export default CoachContactForm;
